import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AddExperienceComponent } from './add-experience/add-experience.component';
import { ExperiencesLogComponent } from './experiences-log/experiences-log.component';
import { ExperienceScheduleComponent } from './experience-schedule/experience-schedule.component';
import { AddOnlineExperienceComponent } from './add-online-experience/add-online-experience.component';
import { AddImageAltComponent } from './add-image-alt/add-image-alt.component';




const routes: Routes = [
    {
        path: '',
        redirectTo: '/add',
        pathMatch: 'full'
      },
    {
      path: 'add',
      component: AddExperienceComponent
    },
    {
      path: 'edit/:id',
      component: AddExperienceComponent
    },
    {
      path: 'image-alt/:id',
      component: AddImageAltComponent
    },
    {
      path: 'list',
      component: ExperiencesLogComponent
    },
    {
      path: 'schedule/:id',
      component: ExperienceScheduleComponent
    },
    {
      path: 'schedule',
      component: ExperienceScheduleComponent
    },
    {
      path: 'online/add',
      component: AddOnlineExperienceComponent
    },
    {
      path: 'online/edit/:id',
      component: AddOnlineExperienceComponent
    }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ExperiencesRoutingModule { }
